import _get from 'lodash/get';
import { UseFormGetValues } from 'react-hook-form';
import { AttachmentFileInputObject } from 'graphql-common';
import DocumentFormFieldNames from '@lib/enums/fieldNames/documentFormFieldNames';
import { AiFieldGenerationSource } from './useAiFieldGeneration';

type Args = {
  getValues: UseFormGetValues<Record<string, unknown>>;
  isEdit?: boolean;
  documentationVersionId?: string;
};

export default function resolveAiFormSource({
  getValues,
  isEdit,
  documentationVersionId,
}: Args): AiFieldGenerationSource | null {
  if (isEdit) {
    return documentationVersionId ? { documentationVersionId } : null;
  }

  const file = _get(getValues(DocumentFormFieldNames.Attachment), 'file') as
    AttachmentFileInputObject | undefined;

  return file ? { file } : null;
}
